module.exports = __webpack_public_path__ + "img/nodata.0537bbd0.png";